import {reduxForm, InjectedFormProps} from 'redux-form';
import Button from '../../components/common/Button';

type Props = {
  onSubmit?: $TSFixMeFunction;
  checkBoxSelected?: boolean;
  localizedStringBundle?: $TSFixMe;
};

export const FcraForm = ({onSubmit, checkBoxSelected, localizedStringBundle}: Props & InjectedFormProps<{}, Props>) => {
  return (
    <form onSubmit={onSubmit} data-testid="fcra-form">
      <div className="m-auto flex h-10 w-fit flex-row justify-center">
        <Button size="medium" variant="primary" disabled={!checkBoxSelected} id="btn-accept-fcra">
          {localizedStringBundle.CONTINUE}
        </Button>
      </div>
    </form>
  );
};
export default reduxForm<{}, Props>({
  form: 'fcraForm',
  touchOnChange: true,
})(FcraForm);
